/**
 * Centralized contact channels for Stratiq.
 * Edit here to update across nav, hero, CTA, contact, footer.
 */
export const WHATSAPP_NUMBER_DISPLAY = "+52 55 1121 7265";
export const WHATSAPP_URL =
  "https://wa.me/525511217265?text=Hola%2C%20me%20interesa%20agendar%20un%20diagn%C3%B3stico%20con%20Stratiq";
export const CONTACT_EMAIL = "info@stratiq.com.mx";
export const MAILTO_URL = `mailto:${CONTACT_EMAIL}`;
